import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/css/shop.css";
import banner1 from "../assets/images/banner-1.jpg";
import forHimBanner from "../assets/images/product/item-1.png";
import img1 from "../assets/images/for-him/image-1.png";
import img2 from "../assets/images/for-him/image-2.png";
import img3 from "../assets/images/for-him/image-3.png";
import img4 from "../assets/images/for-him/image-4.png";
import img5 from "../assets/images/for-him/image-5.png";
import img6 from "../assets/images/for-him/image-6.png";
import img7 from "../assets/images/for-him/image-7.png";
import img8 from "../assets/images/for-him/image-8.png";
import img9 from "../assets/images/for-him/image-9.png";
import { forHerImages } from "./forHerGrid";
import forHerBanner from "../assets/images/product/item-2.png";
import prod1 from "../assets/images/product/product-1.jpeg";
import prod2 from "../assets/images/product/product-2.jpeg";
import prod3 from "../assets/images/product/product-3.jpeg";
import prod4 from "../assets/images/product/product-4.jpeg";

const Shop = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // For Him grid data
    const forHimGrid = [
        { src: img1, name: 'Signature Scent', category: 'For Him', price: '$85' },
        { src: img2, name: 'Classic Elegance', category: 'For Him', price: '$90' },
        { src: img3, name: 'Midnight Musk', category: 'For Him', price: '$75' },
        { src: img4, name: 'Ocean Breeze', category: 'For Him', price: '$110' },
        { src: img5, name: 'Woodland Charm', category: 'For Him', price: '$95' },
        { src: img6, name: 'Urban Oud', category: 'For Him', price: '$120' },
        { src: img7, name: 'Amber Night', category: 'For Him', price: '$105' },
        { src: img8, name: 'Royal Musk', category: 'For Him', price: '$130' },
        { src: img9, name: 'Cedar Dream', category: 'For Him', price: '$99' },
    ];
    const featuredProducts = [
        { id: 1, name: "Mystic Wood", category: "For Him", price: "$85", image: prod1 },
        { id: 2, name: "Rose Petals", category: "For Her", price: "$90", image: prod2 },
        { id: 3, name: "Ocean Breeze", category: "Unisex", price: "$75", image: prod3 },
        { id: 4, name: "Midnight Amber", category: "For Him", price: "$110", image: prod4 }
    ];

    const reviews = [
        { id: 1, name: "Sarah L.", text: "Absolutely love Rose Petals! The scent lasts all day and I get so many compliments.", rating: 5 },
        { id: 2, name: "James D.", text: "Mystic Wood has become my signature scent. Perfect balance of bold and sophisticated.", rating: 5 },
        { id: 3, name: "Emma W.", text: "The presentation and the fragrance are both premium. Highly recommend AR Perfume.", rating: 5 }
    ];

    const collections = [
        { id: 1, title: "Signature Collection", desc: "Our timeless, iconic fragrances." },
        { id: 2, title: "Premium Collection", desc: "Exclusive blends for special occasions." },
        { id: 3, title: "Daily Wear Collection", desc: "Fresh, light scents for everyday use." },
        { id: 4, title: "Gift Collection", desc: "Elegant sets perfect for loved ones." }
    ];

    return (
        <div className="shop-page">
            {/* 1. Premium Hero Section */}
            <section className="shop-hero" style={{ backgroundImage: `url(${banner1})` }}>
                <div className="overlay"></div>
                <div className="hero-content">
                    <h1>Discover Your Signature Fragrance</h1>
                    <p>Experience the luxury of premium, long-lasting fragrances crafted to perfection.</p>
                </div>
            </section>

            {/* For Him Collection Section (Grid Style) */}
            <section className="for-him-collection py-5" style={{ backgroundColor: '#fff' }}>
                <div className="container">
                    <h2 className="section-title text-center mb-5">For Him Collection</h2>
                    <div className="row g-4">
                        {forHimGrid.map((prod, idx) => (
                            <div key={idx} className="col-md-3 col-sm-6">
                                <div className="product-card">
                                    <div className="product-img-wrapper">
                                        <img src={prod.src} alt={prod.name} className="img-fluid" />
                                    </div>
                                    <div className="product-details text-center mt-3">
                                        <span className="product-category">{prod.category}</span>
                                        <h4 className="product-name">{prod.name}</h4>
                                        <p className="product-price">{prod.price}</p>
                                        <button className="btn btn-outline-dark w-100 mt-2">Add to Cart</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* For Her Collection Section (Grid Style) */}
            <section className="for-her-collection py-5" style={{ backgroundColor: '#fff' }}>
                <div className="container">
                    <h2 className="section-title text-center mb-5">For Her Collection</h2>
                    <div className="row g-4">
                        {forHerImages.map((prod, idx) => (
                            <div key={idx} className="col-md-3 col-sm-6">
                                <div className="product-card">
                                    <div className="product-img-wrapper">
                                        <img src={prod.src} alt={prod.name} className="img-fluid" />
                                    </div>
                                    <div className="product-details text-center mt-3">
                                        <span className="product-category">{prod.category}</span>
                                        <h4 className="product-name">{prod.name}</h4>
                                        <p className="product-price">{prod.price}</p>
                                        <button className="btn btn-outline-dark w-100 mt-2">Add to Cart</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 3. Featured Collection */}
            <section className="featured-collection container py-5">
                <h2 className="section-title text-center mb-5">Featured Collection</h2>
                <div className="row g-4">
                    {featuredProducts.map(prod => (
                        <div key={prod.id} className="col-md-3 col-sm-6">
                            <div className="product-card">
                                <div className="product-img-wrapper">
                                    <img src={prod.image} alt={prod.name} className="img-fluid" />
                                </div>
                                <div className="product-details text-center mt-3">
                                    <span className="product-category">{prod.category}</span>
                                    <h4 className="product-name">{prod.name}</h4>
                                    <p className="product-price">{prod.price}</p>
                                    <button className="btn btn-outline-dark w-100 mt-2">Add to Cart</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* 5. Luxury Fragrance Experience */}
            <section className="luxury-experience text-white text-center py-5" style={{ background: "#222", padding: "80px 20px" }}>
                <div className="container">
                    <h2 className="mb-4">The AR Perfume Experience</h2>
                    <p className="lead" style={{ maxWidth: "800px", margin: "0 auto" }}>
                        Our fragrances are more than just scents; they are expressions of personality.
                        Indulge in a world of luxury where every spray is a note of elegance.
                        Experience the artistry of fine perfumery with AR Perfume.
                    </p>
                </div>
            </section>

            {/* 6. Customer Reviews */}
            <section className="customer-reviews container py-5">
                <h2 className="section-title text-center mb-5">What Our Customers Say</h2>
                <div className="row g-4">
                    {reviews.map(review => (
                        <div key={review.id} className="col-md-4">
                            <div className="review-card p-4 shadow-sm h-100 text-center border">
                                <div className="stars text-warning mb-2">
                                    {"★".repeat(review.rating)}
                                </div>
                                <p className="review-text fst-italic">"{review.text}"</p>
                                <h6 className="reviewer-name mt-3 fw-bold">- {review.name}</h6>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* 7. Shop by Collection */}
            <section className="shop-by-collection bg-light py-5">
                <div className="container">
                    <h2 className="section-title text-center mb-5">Shop by Collection</h2>
                    <div className="row g-4">
                        {collections.map(col => (
                            <div key={col.id} className="col-md-3 col-sm-6">
                                <div className="collection-card p-4 text-center border bg-white shadow-sm">
                                    <h5 className="mb-3">{col.title}</h5>
                                    <p className="text-muted">{col.desc}</p>
                                    <Link to="#" className="btn btn-dark btn-sm mt-2">Explore</Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 8. Call-to-Action Section */}
            <section className="cta-section text-center py-5 text-white" style={{ background: "#111", padding: "60px 20px" }}>
                <div className="container">
                    <h2 className="mb-4">Find the Perfect Fragrance for Every Occasion</h2>
                    <div className="d-flex justify-content-center gap-3 flex-wrap">
                        <Link to="/for-him" className="btn btn-outline-light px-4 py-2">Shop For Him</Link>
                        <Link to="/for-her" className="btn btn-outline-light px-4 py-2">Shop For Her</Link>
                        <Link to="#" className="btn btn-light px-4 py-2">Explore Collection</Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Shop;
